var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: _vm.editData.id ? "修改" : "新增",
        visible: _vm.dialogVisible,
        width: "800px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("类型"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("航司"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("船司"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("代码"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "code" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入代码" },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("中文名称"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "nameCH" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.nameCH,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameCH", $$v)
                          },
                          expression: "form.nameCH",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("label", { staticClass: "lable" }, [
                    _c("span", { staticClass: "red" }, [_vm._v("* ")]),
                    _vm._v("英文名称"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "nameEN" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.nameEN,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameEN", $$v)
                          },
                          expression: "form.nameEN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "form-item",
                  staticStyle: { width: "100%", "margin-left": "0" },
                },
                [
                  _c("label", { staticClass: "lable" }, [_vm._v("网址")]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "website" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "660px" },
                        attrs: { placeholder: "请输入网址" },
                        model: {
                          value: _vm.form.website,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "website", $$v)
                          },
                          expression: "form.website",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "form-item",
                  staticStyle: { width: "100%", "margin-left": "0" },
                },
                [
                  _c("label", { staticClass: "lable" }, [_vm._v("备注")]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "remark" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "660px" },
                        attrs: { placeholder: "请输入备注内容" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }